/*
 *   Copyright (c) 2026 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const RELEASE_TICKET_HOLD = gql`
  mutation ReleaseTicketHold($ticketOrderId: ID!) {
    releaseTicketHold(ticketOrderId: $ticketOrderId) {
      ticketOrderId
      status
      releaseReason
    }
  }
`;
